import {forwardRef, useImperativeHandle, useState} from "react";
import {Modal} from "antd";
import ReactHtmlParser from 'react-html-parser';

const MyProPreviewer = (props : any, ref: any) => {

    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => {
        return {
            openPreviewer: () => openPreviewer()
        }
    });

    const openPreviewer = () => {
        setOpen(true)
    }
    const closePreviewer = () => {
        setOpen(false);
    }

    return (
        <Modal open={open} onCancel={closePreviewer} width={960} footer={null}>
            <div>
                <h1 style={{textAlign: "center"}}>{props.details.title}</h1>
                <div style={{textAlign: "center", width: "100%"}}>
                    <img src={props.details.image} alt="" style={{maxWidth: "95%"}} />
                </div>
                <div>{ReactHtmlParser(props.details.content)}</div>
            </div>
        </Modal>
    )
}

export default forwardRef(MyProPreviewer);
